import { render, staticRenderFns } from "./NetworkStatsView.vue?vue&type=template&id=43ae8b79&scoped=true"
import script from "./NetworkStatsView.vue?vue&type=script&lang=ts"
export * from "./NetworkStatsView.vue?vue&type=script&lang=ts"
import style0 from "./NetworkStatsView.vue?vue&type=style&index=0&id=43ae8b79&prod&lang=scss&scoped=true"
import style1 from "./NetworkStatsView.vue?vue&type=style&index=1&id=43ae8b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae8b79",
  null
  
)

export default component.exports